declare global {
    interface Window {
        PDFLib: any;
    }
}

const PDFLIB_SRC = "/pdf-lib.min.js";

/**
 * Loads pdf-lib library
 */
export const loadPdfLibLibrary = async (): Promise<void> => {
    // Check if library is already loaded
    if (window.PDFLib) {
        return;
    }

    // Load the library
    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = PDFLIB_SRC;

        script.onload = () => {
            if (window.PDFLib) {
                resolve();
            } else {
                reject(new Error("pdf-lib library not found on window object"));
            }
        };

        script.onerror = () => {
            reject(new Error("Failed to load pdf-lib library"));
        };

        document.head.appendChild(script);
    });
};

/**
 * Checks if the PDF contains a credential ID in its info dictionary.
 *
 * Important:
 *  Private method "getInfoDict" can be used to access the info dictionary of the PDF document.
 *  See: https://github.com/Hopding/pdf-lib/issues/55#issuecomment-1878678327
 *
 * @param pdfBuffer
 * @returns {Promise<string | null>}
 */
export const extractCertificateIdFromPdf = async (file: File): Promise<string | null> => {
    try {
        await loadPdfLibLibrary();

        const arrayBuffer = await file.arrayBuffer();
        const pdfDoc = await window.PDFLib.PDFDocument.load(arrayBuffer);

        return pdfDoc["getInfoDict"]().get(window.PDFLib.PDFName.of("credentialId"))?.decodeText() || null;
    } catch (error) {
        console.error("Error in advanced certificate ID extraction:", error);
        return null;
    }
};
